module.exports = __webpack_public_path__ + "kruis.svg?4064f89ec86d70ac1f6dd7e53f49f8bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/kruis.svg
// module id = 727
// module chunks = 0